<template>
  <div>
    <div class="vx-row justify-center">
      <div class="vx-col w-full md:w-2/3">
        <vs-card>
          <div slot="header">
            <h3>Buku Tamu</h3>
          </div>
          <div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  size="large"
                  placeholder="Nama Pengunjung"
                  v-model="visitor.name"
                ></vs-input>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  size="large"
                  placeholder="No Telepon"
                  v-model="visitor.phone"
                ></vs-input>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <v-select
                  placeholder="Pilih Layanan"
                  :options="services"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="visitor.service"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <v-select
                  placeholder="Pilih Tipe Pengunjung"
                  :options="guestTypes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="visitor.type"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <v-select
                  placeholder="Pilih Kabupaten/Kota"
                  :options="locations"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="visitor.location"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-textarea label="Alamat Lengkap" v-model="visitor.address" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-textarea label="Keterangan (opsional)" v-model="visitor.description" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                  icon-after
                  @click="saveVisitor"
                >Simpan</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Pengunjung Hari ini</h3>
          </div>
          <div class>
            <vs-table :data="visitors" stripe>
              <template slot="thead">
                <vs-th>No</vs-th>
                <vs-th>Nama Pengunjung</vs-th>
                <vs-th>No Telepon</vs-th>
                <vs-th>Jenis Layanan</vs-th>
                <vs-th>Tipe Pengunjung</vs-th>
                <vs-th>Petugas</vs-th>
                <vs-th>Waktu Kunjungan</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="indextr">{{ visitors.length - (indextr) }}</vs-td>
                  <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                  <vs-td :data="tr.phone">{{ tr.phone }}</vs-td>
                  <vs-td :data="tr.service">{{ tr.service }} ({{tr.agency}})</vs-td>
                  <vs-td :data="tr.status">{{ getGuestType(tr.status) }}</vs-td>
                  <vs-td :data="tr.user">{{tr.user}}</vs-td>
                  <vs-td :data="tr.created_at">{{ tr.created_at }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-card>
      </div>
    </div>
    <vs-popup class="holamundo" title :active.sync="popupActive">
      <div class="vx-row">
        <div class="vx-col w-full text-center">
          <feather-icon
            icon="AwardIcon"
            class="p-6 my-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
        </div>
        <div
          class="vx-col w-full text-center text-4xl font-semibold text-primary"
        >Antrian Online Terdaftar</div>
        <div class="flex flex-col w-full justify-center p-5">
          <div class="w-full text-center font-medium text-4xl">Loket A</div>
          <div class="w-full text-center text-lg">Konsultasi Perizinan</div>
          <div class="w-full text-center flex flex-col py-5">
            <span class="text-6xl text-primary">A-003</span>
            <span class="text-lg">Sisa antrian : 2</span>
          </div>
          <div
            class="w-full text-center text-base"
          >Silahkan menuju ruang tunggu Loket A dan menunggu giliran anda tiba, terima kasih</div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visitor: {
        name: "",
        phone: "",
        service: "",
        description: "",
        type: "",
        address: "",
        location: ""
      },
      services: [],
      visitors: [],
      locations: [],
      popupActive: false
    };
  },
  mounted() {
    this.init();
    this.initEcho();
  },
  methods: {
    init() {
      this.$vs.loading();
      this.$http
        .get("/app/secure/guestbook")
        .then(r => {
          r.data.data.services.map(item => {
            this.services.push({ id: item.id, label: item.name });
          });
          r.data.data.locations.map(item => {
            this.locations.push({ id: item.id, label: item.name });
          });
          this.visitors = r.data.data.visitors;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    saveVisitor() {
      this.$vs.loading();
      this.$http
        .post("/app/secure/guestbook", {
          name: this.visitor.name,
          service_id: this.visitor.service ? this.visitor.service.id : null,
          phone: this.visitor.phone,
          address: this.visitor.address,
          description: this.visitor.description,
          type: this.visitor.type ? this.visitor.type.id : null,
          location_id: this.visitor.location ? this.visitor.location.id : null
        })
        .then(r => {
          this.cleanModel();
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menambah pengunjung.",
            color: "success",
            position: "top-right"
          });
          this.visitors = r.data.data.visitors;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    cleanModel() {
      for (let i in this.visitor) {
        this.visitor[i] = "";
      }
    },
    initEcho() {
      this.userAgent.map(i => {
        this.$echo
          .private(`GuestBook.${i}`)
          .listen("GuestBookUpdatedEvent", e => {
            this.visitors.splice(0, 0, e.guest);
          });
      });
    },
    removeEcho() {
      this.userAgent.map(i => {
        this.$echo.leave(`GuestBook.${i}`);
      });
    },
    getGuestType(id) {
      return this.guestTypes.find(i => {
        return i.id == id;
      }).label;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.removeEcho();
    next();
  },
  computed: {
    ...mapGetters(["userAgent", "guestTypes"]),
    user() {
      return this.$store.state.AppActiveUser;
    }
  },
  components: {
    vSelect
  }
};
</script>>